var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCameraOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33009 21.9194L1.1665 25.083L2.71677 26.6332L7.18326 22.1667L9.51659 19.8334L19.6809 9.6691L21.4053 7.94466L26.8332 2.51681L25.2829 0.966553L19.8069 6.4426L18.0237 8.22576L6.41607 19.8334L4.33009 21.9194ZM5.83317 5.83338H17.1162L14.7829 8.16672H5.83317C4.54451 8.16672 3.49984 9.21139 3.49984 10.5001V17.5C3.49984 18.0466 3.68778 18.5493 4.00257 18.947L2.34708 20.6025C1.61271 19.778 1.1665 18.6911 1.1665 17.5V10.5001C1.1665 7.92272 3.25584 5.83338 5.83317 5.83338ZM17.4998 19.8334H12.8164L10.4831 22.1667H17.4998C20.0061 22.1667 22.0509 20.191 22.1618 17.7122L26.8332 21V7.00005L22.8374 9.8124L19.8332 12.8166V16.0732L19.8332 17.5C19.8332 18.7887 18.7885 19.8334 17.4998 19.8334ZM22.1665 14.8622L24.4998 16.5049V11.4964L22.1665 13.1379V14.8622Z",
    fill: "#F31C4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraOff);
export default __webpack_public_path__ + "static/media/icon-camera_off.4edef1a8472b322efa92ecd2c6b64bba.svg";
export { ForwardRef as ReactComponent };